import { useEarningsInsightsFilter } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter';
import { useKgInsight } from '@terminal/react-query-hooks/insights/useKgInsight';
import { useKgInsightFilter } from '@terminal/react-query-hooks/insights/useKgInsightFilter';

export const useEarningsPreviewAndRecapInsights = (earningsId: string) => {
  const shouldFetchKgInsights = !!earningsId;

  const { data: earningsInsights, isLoading: isKgInsightsLoading } =
    useKgInsightFilter(
      { subject_refs: [{ type: 'earnings', id: earningsId }] },
      shouldFetchKgInsights
    );

  const { data: classicEarningsInsights, isLoading: isClassicInsightsLoading } =
    useEarningsInsightsFilter({
      body: { earnings_ids: [earningsId] },
      isEnabled: !!earningsId,
    });

  const previewInsightId =
    earningsInsights?.find(insight => insight.category === 'earnings_preview')
      ?.id ?? '';
  const recapInsightId =
    earningsInsights?.find(insight => insight.category === 'earnings_recap')
      ?.id ?? '';

  const { data: previewInsight, isLoading: isPreviewInsightLoading } =
    useKgInsight(previewInsightId);
  const { data: recapInsight, isLoading: isRecapInsightLoading } =
    useKgInsight(recapInsightId);

  const hasEarningsInsight =
    !!classicEarningsInsights?.length || !!(previewInsightId || recapInsightId);
  const isInsightsAvailabilityLoading =
    isClassicInsightsLoading || (shouldFetchKgInsights && isKgInsightsLoading);
  const isRecapLoading = isKgInsightsLoading || isRecapInsightLoading;

  return {
    previewInsight,
    previewInsightId,
    recapInsight,
    recapInsightId,
    isPreviewLoading: isKgInsightsLoading || isPreviewInsightLoading,
    isRecapLoading,
    hasRecapData:
      !!recapInsight ||
      !!classicEarningsInsights?.some(insight => insight.type === 'recap'),
    isRecapAvailabilityLoading: isRecapLoading || isClassicInsightsLoading,
    hasEarningsInsight,
    isInsightsAvailabilityLoading,
  };
};
